import { initializeApp, FirebaseApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { config } from "./config";
import { Analytics, getAnalytics, isSupported } from "firebase/analytics";
import { /*getPerformance,*/ FirebasePerformance, initializePerformance } from "firebase/performance";

const app = initializeApp({
  apiKey: config.FIREBASE_API_KEY,
  authDomain: config.FIREBASE_AUTH_DOMAIN,
  projectId: config.FIREBASE_PROJECT_ID,
  storageBucket: config.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: config.FIREBASE_MESSENGER_SENDER_ID,
  appId: config.FIREBASE_APP_ID,
  measurementId: config.FIREBASE_MEASUREMENT_ID,
});

// console.log(
//   "+++++++++++++++++ initializing app_check",
//   config.GOOGLE_RECAPTCHA_SITE_KEY
// );
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(config.GOOGLE_RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
});

let analyticsPromise: Promise<Analytics | null> | null = null;
function getAnalyticsSafe() {
  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((ok) => (ok ? getAnalytics(app) : null))
      .catch(() => null);
  }
  return analyticsPromise;
}

// let performance: ReturnType<typeof initializePerformance> | null = null;
// let performanceInitPromise: Promise<typeof performance> | null = null;

let performance: FirebasePerformance | null = null;
let performanceInitPromise: Promise<FirebasePerformance | null> | null = null;

// export async function ensurePerformance(app: FirebaseApp): Promise<FirebasePerformance> {
//   // hard guards
//   // if (typeof window === "undefined") return null;
//   // if (config.NODE_ENV !== "production") return null;
//   // if (!config.ENABLE_FIREBASE_PERF) return null;

//   // already initialized
//   if (performance) return performance;

//   // already initializing: await it
//   if (performanceInitPromise) return await performanceInitPromise;

//   // start initialization
//   performanceInitPromise = import("firebase/performance")
//     .then(async ({ initializePerformance, isSupported }) => {
//       if (!(await isSupported())) throw new Error("Performance not supported");
//       return initializePerformance(app, {
//         instrumentationEnabled: false,
//         dataCollectionEnabled: false,
//       });
//     });

//   performance = await performanceInitPromise;
//   performanceInitPromise = null;
//   return performance;
//}

export async function ensurePerformance(app: FirebaseApp): Promise<FirebasePerformance | null> {
  if (typeof window === "undefined") return null;
  if (config.NODE_ENV !== "production") return null;
  if (!config.ENABLE_FIREBASE_PERF) return null;

  if (performance) return performance;
  if (performanceInitPromise) return performanceInitPromise;

  performanceInitPromise = import("firebase/performance")
    .then(({ initializePerformance }) =>
      initializePerformance(app, {
        instrumentationEnabled: true,   // you control manual traces
        dataCollectionEnabled: false,
      })
    )
    .catch(() => null);

  performance = await performanceInitPromise;
  performanceInitPromise = null;
  return performance;
}

void ensurePerformance(app);


// async function ensurePerformance() {
//   if (
//     performance ||
//     performanceInitPromise ||
//     config.NODE_ENV !== "production" ||
//     typeof window === "undefined" ||
//     !config.ENABLE_FIREBASE_PERF
//   ) {
//     return performance;
//   }



//   performanceInitPromise = import("firebase/performance")
//     .then(({ initializePerformance }) =>
//       initializePerformance(app, {
//         instrumentationEnabled: false,
//         dataCollectionEnabled: false,
//       })
//     )
//     .catch((err) => {
//       console.warn("Skipping Firebase Performance:", err);
//       return null;
//     })
//     .finally(() => {
//       performance = performanceInitPromise ? performanceInitPromise : null;
//       performanceInitPromise = null;
//     });

//   performance = await performanceInitPromise;
//   return performance;
// }

//void ensurePerformance(); // fire-and-forget when allowed

if (config.NODE_ENV === "production") {
  if(typeof window !== 'undefined') {
    //performance = getPerformance(app);
    performance = initializePerformance(app, { instrumentationEnabled: false, dataCollectionEnabled: false });

  }
}

//const performance = getPerformance(app);

export { appCheck, performance, getAnalyticsSafe };
